const InitialValues = {
  RGBA: {
    valNames: ['Red', 'Green', 'Blue', 'Alpha'],
    maxVals: ['255', '255', '255', '1.0'],
    defaultColorVals: {
      val1: '255',
      val2: '255',
      val3: '0',
      val4: '0.8',
    }
  },
  HSLA: {
    valNames: ['Hue', 'Saturation', 'Lightness', 'Alpha'],
    maxVals: ['360', '100', '100', '1.0'],
    defaultColorVals: {
      val1: '60',
      val2: '100',
      val3: '50',
      val4: '0.8',
    }
  }
}

export default InitialValues